module.exports = __webpack_public_path__ + "static/media/partener.509b32db.svg";